import React, { FC } from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

import './RecentActivityPanelSkeleton.styles.scss';

const Bar: FC<IContentLoaderProps> = ({ width, height, rx = 4, ...rest }) => (
  <ContentLoader
    backgroundColor="#e7f1fc"
    foregroundColor="#ffffff"
    viewBox={`0 0 ${width} ${height}`}
    style={{ width, height }}
    {...rest}
  >
    <rect x="0" y="0" rx={rx} ry={rx} width={width} height={height} />
  </ContentLoader>
);

const PILL_WIDTHS = [90, 110, 80, 100, 70];
const ROW_TEXT_WIDTHS = [280, 220, 250];

const RecentActivityPanelSkeleton: FC = () => (
  <div className="recent-activity-panel-skeleton">
    <div className="recent-activity-panel-skeleton__pills">
      {PILL_WIDTHS.map((width, index) => (
        <Bar key={index} width={width} height={36} rx={18} />
      ))}
    </div>

    <div className="border" />

    {ROW_TEXT_WIDTHS.map((width, index) => (
      <div key={index} className="recent-activity-panel-skeleton__row">
        <Bar width={80} height={60} rx={8} />
        <Bar width={width} height={16} />
      </div>
    ))}
  </div>
);

export default RecentActivityPanelSkeleton;
